export default [
  {
    path: 'administracion/usuarios',
    name: 'users-management',
    meta: { permiso: 'WB001', requiereLogin: true }, // TODO set permission
    component: () => import('@/febos/global/management/vistas/UsersManagement')
  },
  {
    path: 'usuario/perfil/verificacion/esign7',
    name: 'extern-verification-esign7',
    query: { idProceso: '', status: '' },
    // ?:idProceso=&:status=
    meta: { permiso: '*', requiereLogin: true }, // TODO set permission
    component: () => import('@/febos/global/usuario/components/sign/advanced/eSign/UserDataVerificationEsign')
  },
  {
    path: 'usuario/perfil/verificacion/asignapi',
    name: 'extern-verification-asignapi',
    query: { idProceso: '', status: '' },
    // ?:idProceso=&:status=
    meta: { permiso: '*', requiereLogin: true },
    component: () => import('@/febos/global/usuario/components/sign/advanced/aSignApi/UserDataVerification')
  },
  {
    path: 'transactionality',
    name: 'transactionality',
    meta: { permiso: 'TRS01', requiereLogin: true }, // solo superadmin
    component: () => import('@/febos/global/operations/vistas/transactionality/Transactionality')
  },
  {
    path: 'emails',
    name: 'emails',
    meta: { permiso: 'FEB99', requiereLogin: true }, // solo superadmin
    component: () => import('@/febos/global/emails/vistas/emails/List.vue')
  },
  {
    path: 'emails/received',
    name: 'emails/received',
    meta: { permiso: 'FEB99', requiereLogin: true }, // solo superadmin
    component: () => import('@/febos/global/emails/vistas/receivedEmails/ReceivedEmailsList.vue')
  },
  {
    path: 'emails/suppressed',
    name: 'emails/suppressed',
    meta: { permiso: 'FEB99', requiereLogin: true }, // solo superadmin
    component: () => import('@/febos/global/emails/vistas/emails/SuppressedList.vue')
  },
  {
    path: 'transactionality/detail/enterprise/:enterpriseId',
    name: 'holdingDetail',
    meta: { permiso: 'TRS01', requiereLogin: true }, // solo superadmin
    component: () => import('@/febos/global/operations/vistas/transactionality/HoldingDetail')
  },
];
